module.exports = "static/assets/e329f76d7257addc3c4ee622b3270021.svg";